import React from 'react';
export function Footer() {
  return <footer className="bg-brown-dark text-cream-dark/60 py-12 border-t border-gold-main/20" data-id="element-124">
      <div className="max-w-4xl mx-auto px-6 text-center space-y-4 font-lora text-sm" data-id="element-125">
        <p data-id="element-126">Este producto es un ebook digital.</p>
        <p data-id="element-127">
          Los resultados pueden variar según la práctica personal de cada
          lector.
        </p>
        <div className="pt-6 mt-6 border-t border-cream-light/10" data-id="element-128">
          <p data-id="element-129">
            © {new Date().getFullYear()} Paula Giraldo · Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}